import type { MobileAppId } from '@platform/shared-types';
import type { ShellConfig } from '../checkIn';

/**
 * Build-time wiring for an app. The check-in lives on release-service behind
 * the shared `platform` API cluster (P1). The store fallback is used only
 * until an operator sets storeUrl in the update rules.
 */
export function mobileShellConfig(o: {
  app: MobileAppId; platform: 'ios' | 'android'; stage: string;
  domain: { api: string; apiDev: string }; appId: string;
}): { config: ShellConfig; fallbackStoreUrl: string; pushRegisterUrl: string; pushUnregisterUrl: string } {
  const env = o.stage === 'prod' ? 'prod' : 'dev';
  const apiHost = env === 'prod' ? o.domain.api : o.domain.apiDev;
  return {
    config: { app: o.app, platform: o.platform, env, checkInUrl: `https://platform.${apiHost}/release/mobile/check-in` },
    pushRegisterUrl: `https://platform.${apiHost}/push/register`,
    pushUnregisterUrl: `https://platform.${apiHost}/push/unregister`,
    fallbackStoreUrl: o.platform === 'android'
      ? `https://play.google.com/store/apps/details?id=${o.appId}`
      : 'https://apps.apple.com/search?term=RubyTill',
  };
}
